module.exports = __webpack_public_path__ + "static/media/INTRO_demo-bg.79cbb220.jpg";